<div class="grid">
  <div class="col-12">
    <div class="grid">
      <div class="col-7">
        <span class="block mb-2">Name:</span>
        <input class="w-full"  id="transferTaskName" type="text" pInputText [(ngModel)]="taskName" />

      </div>
      <div class="field col-5">
        <span class="block mb-2" >Lieferant:</span>
        <input class="w-full" pInputText readonly    id="transferUserName" [ngModel]="userOrganisation" />
      </div>
      <div class="field col-7">
        <label for="transferAufgabenTyp" >Ziel:</label>
        <p-select [style]="{'width': '100%'}" showClear="true"  filter="false" id="transferAufgabenTyp" [options]="aufgabenArten()" optionLabel="value" optionValue="id" [ngModel]="selectedAufgabenArt()"
        (onChange)="selectAufgabenArtChange($event)"
         placeholder="Typ wählen" appendTo="body">
        </p-select>
      </div>
      <div class="field col-5">&ensp;</div>
      <div class="field col-7">
        <label for="SelectedSortimentsgruppe" >Sortimentsgruppen:</label>
        <p-select   [style]="{'width': '100%'}" showClear="true"  filter="true" id="SelectedSortimentsgruppe" [options]="sortimentGruppen$ | async" optionLabel="name"
        [(ngModel)]="selectedSortimentGruppe"
        [disabled]="!canSelectSortiment()"
        (ngModelChange)="selectedSortimentGruppeChange()" placeholder="nach Sortimentsgruppe filtern" appendTo="body">
        </p-select>
      </div>
      <div class="field col-5">&ensp;</div>
      <div class="field col-7">
        <label for="transferSelectedSortiment" >Sortiment:</label>
        <p-select   [style]="{'width': '100%'}" showClear="true"  filter="true" id="transferSelectedSortiment" [options]="sortimente()" optionLabel="name" [(ngModel)]="selectedSortiment"
        [disabled]="!canSelectSortiment()"
        (ngModelChange)="selectedSortimentChange()" placeholder="Sortiment wählen" appendTo="body">
        </p-select>
      </div>
      <div class="field col-5">&ensp;</div>

    </div>
  </div>
</div>

<div class="grid formAreaSeparatorTop">
    <div class="field col-7"></div>
    <div class="field col-3">
      <button [style]="{'width': '100%'}" pButton [disabled]="!canSaveAndTransfer()" label="Speichern + Versenden" class="p-button-info" (click)="saveAndTransfer()"></button>
    </div>
    <div class="field col-2">
      <button [style]="{'width': '100%'}" pButton [disabled]="!canCancel()" label="Abbrechen" class="p-button-info" (click)="cancel()"></button>
    </div>
</div>
